module.exports = __webpack_public_path__ + "static/media/whistledog-fr.eb2b2f5b.jpg";